import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import { parseReceiptSettings } from '@/lib/printCustomerReceipt'

/**
 * usePraInvoiceEnabled tells the UI whether the tenant has the printed PRA
 * tax-invoice slip turned on (`app_settings.pra_invoice_enabled`). This is
 * INDEPENDENT of the digital fiscal authority (`useFiscalStatus`): a tenant
 * can run PRA slips with or without FBR digital invoicing.
 *
 *   • true  → show PRA column / "Print PRA" / PRA filters & summary
 *   • false → hide all PRA-slip UI
 *
 * Shares the `['settings','all']` query cache with the rest of the app, so
 * this adds no extra network call. Defaults to false until settings load —
 * the same conservative posture as useFiscalStatus.
 */
export function usePraInvoiceEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ['settings', 'all'],
    queryFn: () => apiClient.getAllSettings(),
    staleTime: Infinity,
  })
  const all = data?.data
  return all
    ? parseReceiptSettings(all as Record<string, unknown>).praInvoiceEnabled
    : false
}
